import L from 'leaflet'
import SelectedMarkersControl from '../leaflet-controls/selected-markers-control'
import { inside } from '../helpers/map-helpers'

export default function () {
  let active = false
  let rectangle = null
  let tooltip = null

  L.DomUtil.addClass(this.map._container, 'select-points')

  // named function for normal destroy listener
  const clickFunction = (event) => {
    if (active) {
      const rectangleBounds = [...rectangle.getLatLngs()]

      this.map.off('click', clickFunction, this)
      this.map.off('mousemove', mousemoveFunction, this)
      this.map.off('mouseout', mouseoutFunction, this)
      this.map.removeLayer(rectangle)

      if (tooltip) {
        tooltip.remove()
        tooltip = null
      }
      rectangle = null

      const markers = []

      this.map.eachLayer(layer => {
        if (layer instanceof L.Marker && layer.options.selected && inside(layer.getLatLng(), rectangleBounds[0])) {
          markers.push(layer)
        }
      })

      if (markers.length) {
        new SelectedMarkersControl({
          vue: this,
          _markers: markers
        }).addTo(this.map)
      }
    } else {
      active = true
      rectangle = L.rectangle([event.latlng, event.latlng], { color: "#03A9F4", weight: 1, dashArray: '3, 6' }).addTo(this.map)
    }
  }

  const mousemoveFunction = (event) => {
    if (active && event.latlng) {
      const currentLatLng = rectangle.getLatLngs()
      rectangle.setBounds([currentLatLng[0], event.latlng])
    } else if (tooltip && event.latlng) {
      tooltip.setLatLng(event.latlng)
    } else if (!tooltip && event.latlng) {
      tooltip = L.tooltip({
        permanent: true,
        offset: L.point({ x: 0, y: -5 }),
        direction: 'top'
      }).setContent('To select click LMB.')

      tooltip.setLatLng(event.latlng).addTo(this.map)
    }
  }

  const mouseoutFunction = () => {
    if (tooltip) {
      tooltip.remove()
      tooltip = null
    }
  }

  this.map.on('click', clickFunction, this)
  this.map.on('mousemove', mousemoveFunction, this)
  this.map.on('mouseout', mouseoutFunction, this)
}